module.exports = __webpack_public_path__ + "static/media/icra25atlanta.aa08bd92.jpeg";